
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { API } from "../../services/api";
import profileimg from "../../assets/img/profile/profile-img.svg"
const ProfileCommunity = (props) => {
    const Group = require("../../assets/img/Featured icon.jpg");
    
    return (
        <div>
            <Modal show={props.isCommunity} onHide={props.handleClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div>
                            <img src={Group} className="singupimage"></img>

                        </div>
                        <div className="header">
                            <h4 className="modal-tittle" >Community</h4>
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <ul className="profile-community d-flex flex-wrap p-0 m-0">
                       {props.community?.map((community, index) => (
                       <li className="community-list-itm" >
                         <img src={community?.communityId?.profileImage?.url ? API.uploadFilePath + community?.communityId?.profileImage?.url : profileimg} alt="test" className="community_thumb" />
                         <span>{community.communityId.communityName}</span>
                       </li>))}
                       

                        
                    </ul>

                </Modal.Body>
                <Modal.Footer className="modal-center" >
                    <Button variant="secondary" className="pop-primary" onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>

        </div >
    );
};
export default ProfileCommunity;
